import React, {Component, Fragment} from 'react';
import PropTypes from "prop-types";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {TEXT} from "../../utilities/strings";
import {USER_GUIDE_PUBLIC_FILE} from "../../utilities/constants";

/**
 * Component to render more information modal for each section.
 * Properties used to pass in title and body copy text.
 *
 * @example
 * <SectionModal title={TEXT} body={TEXT}/>
 */
export default class SectionModal extends Component {

  static propTypes = {
    title: PropTypes.node,
    body: PropTypes.node
  };

  state = {
    show: false
  }

  handleShow = () => this.setState({show: true})
  handleClose = () => this.setState({show: false})

  render() {
    const userGuideLink = `${process.env.PUBLIC_URL}/${USER_GUIDE_PUBLIC_FILE}`;

    return (
      <Fragment>

        <div>
          <Button variant="link" type="button" size="sm" onClick={this.handleShow}>
            {TEXT.more_information}
          </Button>
        </div>

        <Modal dialogClassName="AppModal" show={this.state.show} onHide={this.handleClose}>

          <Modal.Header>
            <h4>{this.props.title}</h4>
          </Modal.Header>

          <Modal.Body>
            {this.props.body}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="link" type="button" size="sm" href={userGuideLink} target="_blank">
              {TEXT.user_guide}
            </Button>

            <div className="flex-grow-1"/>

            <Button variant="primary" size="sm" onClick={this.handleClose}>
              {TEXT.modal_close}
            </Button>
          </Modal.Footer>

        </Modal>
      </Fragment>
    )
  }
}
